import {
  API_ENDPOINT,
  useClientApiV1AccountsInventoryQuery,
} from '../../resources/@types/accountSchema';

function useClientAccountInventoryQuery(
  options?: Parameters<typeof useClientApiV1AccountsInventoryQuery>[0]['options'],
) {
  return useClientApiV1AccountsInventoryQuery({
    queryKey: [API_ENDPOINT.CLIENT_V1_ACCOUNTS_INVENTORY],
    url: API_ENDPOINT.CLIENT_V1_ACCOUNTS_INVENTORY,
    options,
  });
}

useClientAccountInventoryQuery.queryKey = [API_ENDPOINT.CLIENT_V1_ACCOUNTS_INVENTORY];

export default useClientAccountInventoryQuery;
